<script setup lang="ts">
const { state } = useAppStore()
</script>

<template>
    <div>
        <UContainer>
            <div class="w-full flex gap-x-4 items-center max-[769px]:flex-wrap max-[769px]:gap-x-0 max-[769px]:-m-4">
                <div
                    v-for="item in state.tresholds"
                    :key="item.id"
                    class="flex items-center gap-x-2.5 text-chsc-indigo-500 max-[769px]:w-1/2 max-[769px]:p-4 max-[641px]:w-full"
                >
                    <img
                        :src="item.icon.filename"
                        class="w-[50px]"
                    >
                    <UIcon
                        name="i-lucide-move-right"
                        class="fs-4xl"
                    />
                    <div class="flex flex-col gap-y-1">
                        <p class="fs-xs">
                            {{ item.label }}
                        </p>
                        <p
                            v-if="item.from != 0 || item.to != 0"
                            :class="[
                                'fs-xs font-semibold',
                                { 'text-[#79DD7D]': item.id == 1 },
                                { 'text-[#FFE981]': item.id == 2 },
                                { 'text-[#E89903]': item.id == 3 },
                                { 'text-[#FF6464]': item.id == 4 },
                                { 'text-[#929292]': item.id == 5 },
                            ]"
                        >
                            {{ item.to }}% - {{ item.from }}%
                        </p>
                    </div>
                </div>
            </div>
        </UContainer>
    </div>
</template>
